import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'handicapSbv' })
export class HandicapSbvPipe implements PipeTransform {
  transform(sbv: string): string {
    if (isNaN(+sbv)) {
      return sbv;
    }
    if (+sbv < 0) {
      return '(0:' + Math.abs(+sbv) + ')';
    } else {
      return '(' + sbv + ':0)';
    }
  }
}
